import { useFormikContext } from 'formik';

import { Button } from '@/components/ui/button';

import type { AgentCreateFormValues } from '@/schemas/agent.schema';

import type { AgentTemplate } from '@/types/agent.type';

type AgentCreatePageNextButtonProps = {
  step: number;
  handleNext: () => void;
  templates: AgentTemplate[];
};

export const AgentCreatePageNextButton = ({
  step,
  handleNext,
  templates,
}: AgentCreatePageNextButtonProps) => {
  const { values, errors, setFieldValue } = useFormikContext<AgentCreateFormValues>();

  const canProceed = () => {
    if (step === 1) return values.template_id !== null;
    if (step === 20) return Object.keys(errors).length === 0;
    return false;
  };

  const handleClick = () => {
    if (step === 1) {
      if (values.template_id && values.template_id !== 'blank') {
        const selected = templates.find(t => t.id === values.template_id);
        if (selected) {
          setFieldValue('agent_name', selected.name);
          setFieldValue('description', selected.description);
        }
      } else if (values.template_id === 'blank') {
        // Clear any data prefilled by a previously selected template
        setFieldValue('agent_name', '');
        setFieldValue('description', '');
      }
    }
    handleNext();
  };

  return (
    <div className="flex items-center justify-end w-full mt-4">
      <Button onClick={handleClick} disabled={!canProceed()}>
        Next
      </Button>
    </div>
  );
};
